import React, { useState, useEffect } from 'react';
import Carousel from '../components/Carousel';
import Layout from '../components/Layout';
import BrandLogos from '../components/BrandLogos'; // Import the new component
import { useNavigate } from 'react-router-dom';
import InstagramFeed from '../components/InstagramFeed';
import { warmUpServer } from '../services/api'; // Import the health check function

const HomePage = () => {
    const [offers] = useState([
        {
            imageUrl: 'https://cdn.media.amplience.net/i/frasersdev/sdmy-new-balance-sale-1920x960?fmt=auto&upscale=false&w=991&h=496&sm=c&$h-ttl$',
            title: 'Summer Sale',
            description: 'Up to 70% off on selected items',
        },
        {
            imageUrl: 'https://t4.ftcdn.net/jpg/05/75/66/89/360_F_575668954_S1gEB20aXo6jiZInbD2rURWZyYK8ZMww.jpg',
            title: 'New Arrivals',
            description: 'Check out our latest collection',
        },
        {
            imageUrl: 'https://t3.ftcdn.net/jpg/04/51/37/36/360_F_451373635_pyjvnCm3sKzhyhozxa2LdfOGo5XE5GvNu.jpg',
            title: 'Special Deals',
            description: 'Limited time offers on premium brands',
        },
    ]);
    const navigate = useNavigate();

    // Call the health endpoint when the HomePage component mounts
    useEffect(() => {
        warmUpServer();
    }, []); // Empty dependency array ensures this runs only once on mount

    // Handle search input and redirect to /search page
    const handleSearch = (query) => {
        if (query.trim()) {
            navigate(`/search?query=${encodeURIComponent(query)}`);
        }
    };

    return (
        <Layout onSearch={handleSearch}>
            <div className="min-h-screen bg-gray-50">
                {/* Hero Section with Carousel */}
                <div className="mb-16">
                    <Carousel offers={offers} />
                </div>

                {/* Featured Categories */}
                <div className="mb-20">
                    <BrandLogos />
                </div>

                {/* Instagram Feed Section */}
                <div className="mb-16">
                    <InstagramFeed />
                </div>
            </div>
        </Layout>
    );
};

export default HomePage;